import criticalError from './critical-error';
import networkStatus from './network-status';

export default {
  criticalError,
  networkStatus,
};
